<template>
  <div class="login">
    <div class="row w-100 h-100">
      <div id="map-section">
        <div id="world-map-markers"></div>
      </div>
      <div id="login-section" class="position-absolute">
        <div class="container px-0 pt-4">
          <img class="logo mb-4" alt="logo" src="../assets/logo.svg" />

          <div class="text-left mt-5">
            <h4>Sign In</h4>
            <div class="mt-4">
              <form action="/action_page.php">
                <div class="form-group">
                  <label class="mb-0" for="username">Username</label>
                  <div data-v-08944749 class="input-icon">
                    <span data-v-08944749 class="icon">
                      <svg
                        data-v-08944749
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fal"
                        data-icon="user"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        class="svg-inline--fa fa-user fa-w-14"
                      >
                        <path
                          data-v-08944749
                          fill="currentColor"
                          d="M313.6 288c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zM416 464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-41.6C32 365.9 77.9 320 134.4 320c19.6 0 39.1 16 89.6 16 50.4 0 70-16 89.6-16 56.5 0 102.4 45.9 102.4 102.4V464zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm0-224c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
                          class
                        />
                      </svg>
                    </span>
                    <span data-v-08944749 class="input">
                      <input data-v-08944749 type="text" class="form-control" />
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label class="mb-0" for="pwd">Password</label>
                  <div data-v-08944749 class="input-icon">
                    <span data-v-08944749 class="icon">
                      <svg
                        data-v-08944749
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fal"
                        data-icon="key"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        class="svg-inline--fa fa-key fa-w-16"
                      >
                        <path
                          data-v-08944749
                          fill="currentColor"
                          d="M336 32c79.529 0 144 64.471 144 144s-64.471 144-144 144c-18.968 0-37.076-3.675-53.661-10.339L240 352h-48v64h-64v64H32v-80l170.339-170.339C195.675 213.076 192 194.968 192 176c0-79.529 64.471-144 144-144m0-32c-97.184 0-176 78.769-176 176 0 15.307 1.945 30.352 5.798 44.947L7.029 379.716A24.003 24.003 0 0 0 0 396.686V488c0 13.255 10.745 24 24 24h112c13.255 0 24-10.745 24-24v-40h40c13.255 0 24-10.745 24-24v-40h19.314c6.365 0 12.47-2.529 16.971-7.029l30.769-30.769C305.648 350.055 320.693 352 336 352c97.184 0 176-78.769 176-176C512 78.816 433.231 0 336 0zm48 108c11.028 0 20 8.972 20 20s-8.972 20-20 20-20-8.972-20-20 8.972-20 20-20m0-28c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
                          class
                        />
                      </svg>
                    </span>
                    <span data-v-08944749 class="input">
                      <input data-v-08944749 type="password" class="form-control" />
                    </span>
                  </div>
                </div>
                <button type="button" class="btn btn-block mt-5" @click="authenticateUser">Sign In</button>
              </form>
            </div>
          </div>
        </div>
        <footer class="page-copyright">
          <p class="mb-0 mb-md-2" style="font-size:12px;">POWERED BY</p>
          <p>
            <img
              src="../assets/logo-footer.png"
              data-rjs="2"
              style="margin-top:-5px;margin-right:5px;vertical-align: middle;display: inline;"
              width="28"
              height="28"
            />
            <a
              target="_blank"
              style="font-size:16px; color:#161E44;vertical-align: middle;display: inline;"
              href="https://vedicium.com/"
            >VeDicium</a>
          </p>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
window.jQuery = require("jquery");
require("jvectormap");
require("../assets/js/world-en");

export default {
  name: "Login",
  mounted: function() {
    window.jQuery("#world-map-markers").vectorMap({
      map: "world_merc",
      zoomButtons: false,
      scaleColors: ["#C8EEFF", "#0071A4"],
      normalizeFunction: "polynomial",
      hoverOpacity: 0.7,
      hoverColor: false,
      markerStyle: {
        initial: {
			"stroke-width": "4px",
			r: 10,
			fill: "transparent",
			stroke: "rgba(0, 29, 62, 0.75)"
		},
		hover: {
			"stroke-width": "0px",
			"stroke-opacity": .75,
			"fill-opacity": .75,
			r: 12,
			stroke: "rgba(0, 29, 62, 0.75)",
			fill: "rgba(0, 29, 62, 0.75)",
		}
      },
      backgroundColor: "#F2F5F6",
      regionStyle: {
        initial: {
          fill: "#b5bfc8"
        }
      },
      markers: [{ latLng: [41.9, 12.45], name: "Vatican City" }]
    });
  },
  methods: {
    authenticateUser() {
      localStorage.setItem("jwt", "sample-token-here");
      this.$router.push("/");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../assets/css/jvectormap.css";
#map-section {
  height: 100%;
  width: calc(100% - 450px);
}

.login {
  width: 100vw;
  height: 100vh;
  background-color: rgb(242, 245, 246);
}

#world-map-markers {
  widows: 100%;
  height: 100vh;
}

.logo {
  width: 100%;
}

.container h4 {
  color: #5b5b5b;
}

.container label {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
}

span#username-label {
  color: #5b5b5b;
  background: url("../assets/user.svg") no-repeat;
  background-size: 60%;
  background-position: center;
  border: 1px solid #ffffff;
  box-shadow: 1px 0px 0px rgba(206, 206, 206, 0.5);
}

span#password-label {
  color: #5b5b5b;
  background: url("../assets/key.svg") no-repeat;
  background-size: 60%;
  background-position: center;
  border: 1px solid #ffffff;
  box-shadow: 1px 0px 0px rgba(206, 206, 206, 0.5);
}

input {
  border: none;
  box-shadow: 0 1px 2px 1px rgba(180, 180, 180, 0.5);
  color: #5b5b5b;
  padding-left: 45px;
  outline: none !important;
}

input:focus {
  outline: none !important;
  border: 2px solid #001d3e;
  box-shadow: inset 0 -1px 0 #ddd;
}

.input-group {
  background: #ffffff;
  box-shadow: 0px 1px 1px rgba(206, 206, 206, 0.5);
  border-radius: 10px;
}

.input-icon {
  position: relative;
}

div.input-icon .icon {
  width: 30px;
  text-align: center;
  color: #495057;
  position: absolute;
  font-size: 18px;
  font-weight: 400;
  left: 10px;
  top: 0px;
  border-right: 1px solid #ced4dd;
  padding-right: 10px;
  padding-top: 6px;
  height: 100%;
}

.form-group span {
  margin-top: inherit;
  color: #6d757e;
  display: inline;
}
button {
  background: #001d3e;
  border-radius: .25rem;
  color: white;
  transition: 0.5s;
}

button:hover {
  color: white;
  background: #99a1aa;
}

.page-copyright {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 50px 60px;
  text-align: center;
}

.pulsating-circle {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 30px;
  height: 30px;
}
.pulsating-circle:before {
  content: "";
  position: relative;
  display: block;
  width: 300%;
  height: 300%;
  box-sizing: border-box;
  margin-left: -100%;
  margin-top: -100%;
  border-radius: 45px;
  background-color: #001d3e;
  animation: pulse-ring 1.25s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
}
.pulsating-circle:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  display: block;
  width: 100%;
  height: 100%;
  background-color: #001d3e;
  border-color: #001d3e;
  border-radius: 15px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
  animation: pulse-dot 1.25s cubic-bezier(0.455, 0.03, 0.515, 0.955) -0.4s infinite;
}

#login-section {
  width: 470px;
  top: 0;
  right: 0;
  height: auto;
  min-height: 100%;
  padding: 20px 60px 180px;
  background-color:#fff;
}

@keyframes pulse-ring {
  0% {
    transform: scale(0.33);
  }
  80%,
  100% {
    opacity: 0;
  }
}
@keyframes pulse-dot {
  0% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.8);
  }
}

@media screen and (max-width: 768px) {
  #login-section {
    max-width: 100%;
    left: 0;
    padding: 40px;
  }

  .logo {
    height: auto;
  }

  .container {
    margin-top: 0px !important;
  }

  .page-copyright {
    position: static;
    display: block;
    margin-top: 40px !important;
  }

  .login {
    font-size: 3rem;
  }

  .row.w-100 {
    margin: 0;
  }

  .page-copyright {
    top: 100%;
  }
  .col-sm-12.col-md-2 {
    padding: 0;
  }

  .container {
    margin: 0 auto;
  }
  .text-left.mt-4 {
    padding: 0 20px;
  }

  .logo {
    width: 100%;
  }

  .page-copyright {
    top: calc(100vh - 100px) !important;
    margin: 0;
  }

  .mt-4 {
	  margin-top: 0px;
  }

  .mt-5 {
	  margin-top: 2rem !important;
  }
  
  .form-group {
	  margin-bottom: 0px;
	  line-height: 1;
  }
}
@media screen and (max-width: 768px) {
	#login-section {
		width:100%;
	}
}
@media screen and (max-width: 359px) {
  .page-copyright {
    top: 100% !important;
  }
}
</style>
